import { render, staticRenderFns } from "./SendLetter.vue?vue&type=template&id=474711b0&"
import script from "./SendLetter.vue?vue&type=script&lang=js&"
export * from "./SendLetter.vue?vue&type=script&lang=js&"
import style0 from "./SendLetter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports